import type { Route } from '@polaris/core/services'
import { apiClient } from './client'

export interface GetHistoryRequest {
  wallets: string[]
  page?: string
  'per-page'?: string
}

interface GetHistoryResponse {
  routes: Route[]
  page: number
}

/** Returns a paginated history of routes. */
export function getHistory({
  wallets,
  page,
  'per-page': perPage,
}: GetHistoryRequest): Promise<GetHistoryResponse> {
  // Return empty result if no wallets provided to avoid unnecessary API calls
  if (wallets.length === 0) {
    return Promise.resolve({
      routes: [],
      page: Number(page) || 1,
    })
  }

  const searchParams = new URLSearchParams()
  for (const address of wallets) {
    if (!address) continue
    searchParams.append('wallets', address)
  }
  if (page) searchParams.append('page', page)
  if (perPage) searchParams.append('per-page', perPage)

  return apiClient
    .get('history', {
      searchParams: searchParams.toString(),
    })
    .json()
}
